import { Icon, Space } from '@sravni/react-design-system';
import { StarFilled } from '@sravni/react-icons';

export const TopOffersColumn: FC<{ item: any }> = (props) => {
  const { item } = props;
  if (typeof item === 'string') {
    return <span>{item}</span>;
  }

  if (item && typeof item === 'object' && 'type' in item && item.type === 'rating') {
    return item.text ? (
      <Space
        direction="row"
        align="center"
      >
        <Icon
          color="orange"
          icon={<StarFilled />}
        />{' '}
        {item.text}
      </Space>
    ) : null;
  }

  return null;
};
